export default __webpack_public_path__ + "static/media/logo-dark.d738f4ab.png";